import { gridBreakpoints } from '../globals/screen';
/**
 * Grid containers
 * Define the maximum width of `.container` for different screen sizes.
 */
const containerMaxWidths = {
    sm: '100%',
    md: '100%',
    lg: '100%',
    xl: '1440px',
};
/**
 * Grid columns
 * Set the number of columns and specify the width of the gutters.
 */
const columnsTotal = 12;
const gutterWidth = 24;
const grid = {
    columns: columnsTotal,
    gutter: gutterWidth,
    breakpoints: {
        xs: `${gridBreakpoints.xs}px`,
        md: `${gridBreakpoints.md}px`,
        lg: `${gridBreakpoints.lg}px`,
        xl: `${gridBreakpoints.xl}px`,
    },
    containerMaxWidths: {
        md: containerMaxWidths.md,
        lg: containerMaxWidths.lg,
        xl: containerMaxWidths.xl,
    },
};
export default grid;
